import config from "@nusrif/config";
import { formatCurrency } from "@nusrif/utils";
interface CartItemPriceProps {
  price: number;
  mrpPrice?: number;
  currencyCode?: string;
}
export const CartItemPrice = ({ price, currencyCode }: CartItemPriceProps) => {
  const code = currencyCode || config.region.currencyCode;
  const formattedPrice = formatCurrency(price, code);
  return (
    <div className="flex items-center gap-2">
      <span className="font-bold text-[#1e4aa8] text-lg">{formattedPrice}</span>
    </div>
  );
};